import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// import { BsLocaleService } from 'ngx-bootstrap/';
import { BsModalService } from 'ngx-bootstrap/modal/bs-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageInsitutionManagementService } from '../../ph-bhp-feature-package-insitution-management.service';
import { PHBHPFeaturePackageConfigurationService } from 'src/app/configure/ph-bhp-feature-package-configuration.service';
import { DatePipe } from '@angular/common';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-overview-detail',
  templateUrl: './overview-detail.component.html',
  styleUrls: ['./overview-detail.component.css']
})
export class OverviewDetailComponent implements OnInit {

  institutionData: any;
  subscription: Subscription;
  institutionId = 0;
  isgroup = false;
  groupInstitutionlist = [];
  recentExport: any;
  langChoosen: string;
  translationKeys: typeof TranslationKeys = TranslationKeys;


  constructor(
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    public config: AppConfig,
    private service: PHBHPFeaturePackageInsitutionManagementService,
    private configService: PHBHPFeaturePackageConfigurationService,
    private datePipe: DatePipe,
    public layoutService: PHBHPLayoutPackageService
  ) { }

  ngOnInit() {
    this.institutionId = this.activatedRoute.snapshot.parent.params.id;
    this.loadPageDetails();
    this.subscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      this.getInstitutionDetails();
      this.langChoosen = changelang;
      var lang = localStorage.getItem('selectedlanguage');
      if (lang === 'en') {
        lang = 'en-GB';
      }
      if(this.recentExport) {
       if(this.recentExport.recentObservationExportedOn) {
         const date1 = this.layoutService.convertUTCDateToLocalDate(new Date(this.recentExport.recentObservationExportedOn));
         this.recentExport.recentObservationExportedOn =   date1.toLocaleDateString(lang, {month: '2-digit', day: '2-digit', year: 'numeric'}) +" "+date1.toLocaleTimeString(lang, {hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false});
       } 
       if(this.recentExport.recentConsumptionExportedOn) {
         const date2 = this.layoutService.convertUTCDateToLocalDate(new Date(this.recentExport.recentConsumptionExportedOn));
         this.recentExport.recentConsumptionExportedOn = date2.toLocaleDateString(lang, {month: '2-digit', day: '2-digit', year: 'numeric'}) +" "+date2.toLocaleTimeString(lang, {hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false});
       }
      }
    });
  }

  loadPageDetails() {
    this.getInstitutionDetails();
  }

  getInstitutionDetails() {
    this.layoutService.showLoader = true;
    this.service.GetInstitutionDetails(this.institutionId).subscribe((res: any) => {
      this.institutionData = res;
      if (this.institutionData.groupInstitutions == null) {
        this.isgroup = true;
      } else {
        this.isgroup = false;
      }

      if (this.institutionData.groupInstitutions) {
        this.institutionData.groupInstitutions.forEach(item => {
          if (!item.institution.isGroup) {
            this.groupInstitutionlist.push(item.institution.institutionName);
          }
        });
      }

      if (this.config.userData && this.institutionData && this.config.userData.roleName.roleId === 4
         && this.institutionData.institution.institution && this.institutionData.institution.institution.activateWebKess) {
        this.getInstitutionWebKessRecentExportDetail();
      }
      this.layoutService.showLoader = false;
    }, err => {
      this.layoutService.showLoader = false;
    });

  }

  getInstitutionWebKessRecentExportDetail() {
    this.layoutService.showLoader = true;
    this.langChoosen = localStorage.getItem('selectedlanguage');
    this.configService.GetInstituionWebKessRecentExportDetail(this.institutionId).subscribe((exportRes: any) => {
      this.recentExport = exportRes;
      var lang = localStorage.getItem('selectedlanguage');
      if (lang === 'en') {
        lang = 'en-GB';
      }
      if(this.recentExport.recentObservationExportedOn) {
        const date1 = this.layoutService.convertUTCDateToLocalDate(new Date(this.recentExport.recentObservationExportedOn));
        this.recentExport.recentObservationExportedOn =   date1.toLocaleDateString(lang, {month: '2-digit', day: '2-digit', year: 'numeric'}) +" "+date1.toLocaleTimeString(lang, {hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false});
      } 
      if(this.recentExport.recentConsumptionExportedOn) {
        const date2 = this.layoutService.convertUTCDateToLocalDate(new Date(this.recentExport.recentConsumptionExportedOn));
        this.recentExport.recentConsumptionExportedOn = date2.toLocaleDateString(lang, {month: '2-digit', day: '2-digit', year: 'numeric'}) +" "+date2.toLocaleTimeString(lang, {hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false});
      }
      this.layoutService.showLoader = false;
    });
  }

}
